defualt_success:
  &fail false
defulat_result_code:
  &result_code "00"

Error:
  value: {
    "success": *fail,
    "all": "error",
    "result_code": *result_code
  }

InputValueIsInvalid:
  description: 無効な値が入力された場合。
  value: {
    "success": *fail,
    "all": "Input value is invalid.",
    "result_code": *result_code
  }

InvalidLogin:
  description: 無効なパスワードを入力した場合。
  value: {
    "success": *fail,
    "all": "Invalid login information",
    "result_code": *result_code
  }

NoAccount:
  description: 入力されたアカウント情報が正しくない場合。
  value: {
    "success": *fail,
    "all": "Invalid login information",
    "result_code": *result_code
  }

DoNotHavePermission:
  description: アクセストークン発行の権限がない場合。
  value: {
    "success": *fail,
    "all": "You do not have a permission",
    "result_code": *result_code
  }

null:
  description: 入力されたアカウント情報が正しくない場合。
  value: {
    "success": *fail,
    "all": "Invalid login information",
    "result_code": *result_code
  }



ExpiredEmailOtp:
  description: 有効時間が過ぎたOTPを入力した場合。
  value: {
    "success": *fail,
    "all": "Valid time has expired.",
    "result_code": "1202"
  }

InvalidOtp:
  description: 無効なOTPを入力した場合。
  value: {
    "success": *fail,
    "all": "Incorrect verification code. Please try again",
    "result_code": "1201"
  }

TooManyOtpRequests:
  description: 定められた回数以上のOTPを入力した場合。
  value: {
    "success": *fail,
    "all": "Abnormal request for access permission is noticed. Please try again.",
    "result_code": *result_code
  }

InvalidId:
  description: 無効な**会社コード**または**ID**を入力した場合。
  value: {
    "success": *fail,
    "all": "Company ID / ID is invalid.",
    "result_code": *result_code
  }

InvalidEmail:
  description: 無効な**Eメール**を入力した場合。
  value: {
    "success": *fail,
    "all": "Email is incorrect. Please enter the email of your account.",
    "result_code": *result_code
  }

InvalidBatchSeq:
  description: 無効な**配置固有キー**を入力した場合。
  value: {
    "success": *fail,
    "all": "empty_forgotpassword",
    "result_code": "01",
    "login_url": "https://dweb.directcloud.jp/login",
    "password_policy": {
      "password_min_length": "8",
      "password_string_type": "0",
      "password_continuation_limit": "0",
      "password_past_use": "Y"
    }
  }

EmptyForgotPassword:
  description: 無効な**配置固有キー**を入力した場合。
  value: {
    "success": *fail,
    "all": "empty_forgotpassword",
    "result_code": "01"
  }

VerifyPassword:
  description: 無効な**password**または**password_confirm**を入力した場合。
  value: {
    "success": *fail,
    "all": "Please verify your password.",
    "result_code": *result_code
  }

NotExist:
  description: ファイルまたはコメントが存在しない場合。
  value: {
    "success": false,
    "all": "File or comment does not exist.",
    # OAuth
  }